import { getCart } from "../utils/getCart";
import { changeCart } from "../utils/changeCart";
import { addCart } from "../utils/addCart";

const addOnCheck = () => {
  const addOnEnable = document.body.dataset.addon;
  if (addOnEnable === "true") {
    document.addEventListener("updated_cart", async () => {
      const cart = await getCart();
      const cartLimit = Number(document.body.dataset.addonLimit);
      const addOnFree = JSON.parse(document.body.dataset.addonFree);
      const addOnPaying = JSON.parse(document.body.dataset.addonPaying);

      // check cart
      let addOnPayingInCart = false;
      let addOnPayingQty = 0;
      let addOnFreeInCart = false;
      cart.items.forEach((item) => {
        if (item.id === addOnPaying.id) {
          addOnPayingInCart = true;
          addOnPayingQty = item.quantity;
        }
        if (item.id === addOnFree.id) {
          addOnFreeInCart = true;
        }
      });

      // check if cart is over limit

      const cartTotal = cart.total_price - addOnPaying.price * addOnPayingQty;
      let cartIsOverLimit = false;
      if (cartTotal >= cartLimit) {
        cartIsOverLimit = true;
      }

      // check if cart is under limit
      let cartIsUnderLimit = false;
      if (cartTotal < cartLimit) {
        cartIsUnderLimit = true;
      }

      // update cart if paying add-on is in cart and cart total is equal or over limit
      if (addOnPayingInCart && cartIsOverLimit && !addOnFreeInCart) {
        console.log("update cart with free add-on");
        // remove 1 paying addon product
        const newQtyAddOnPaying = addOnPayingQty - 1;
        const RemoveAddOnPaying = {
          id: addOnPaying.id.toString() as string,
          quantity: newQtyAddOnPaying.toString(),
        };
        await changeCart(RemoveAddOnPaying);

        // add 1 free addon product
        const newQtyAddOnFree = 1;
        // turn number to strings

        const AddAddOnFree = {
          items: [
            {
              id: addOnFree.id.toString() as string,
              quantity: newQtyAddOnFree.toString(),
            },
          ],
        };
        await addCart(AddAddOnFree);

        // dispatch update event
        update_cart(function () {
          var event = document.createEvent("Event");
          event.initEvent("updated_cart", true, true);
          document.dispatchEvent(event);
        });
      }

      // update cart if free add-on is in cart and cart total is under limit
      if (cartIsUnderLimit && addOnFreeInCart) {
        console.log("update cart with paying add-on");
        // remove free addon product
        const updateQtyAddOnFree = 0;
        const RemoveAddOnFree = {
          id: addOnFree.id.toString() as string,
          quantity: updateQtyAddOnFree.toString(),
        };
        await changeCart(RemoveAddOnFree);

        // add 1 paying addon product
        const updateQtyAddOnPaying = 1;
        console.log("add paying add-on");
        const AddAddOnPaying = {
          items: [
            {
              id: addOnPaying.id.toString() as string,
              quantity: updateQtyAddOnPaying.toString(),
            },
          ],
        };
        await addCart(AddAddOnPaying);

        // dispatch update event
        update_cart(function () {
          var event = document.createEvent("Event");
          event.initEvent("updated_cart", true, true);
          document.dispatchEvent(event);
        });
      }
    });
  }
};

export { addOnCheck };
